import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_FAILURE
} from '../constants'

export function* getYearsDataMasterSaga({data:{brandId, modelId}}) {
  try {
      
    if(brandId && modelId){

      const result =  yield call(BFFAgent.Datamasters.getYears, brandId, modelId)
      const yearsList = result?.data?.data

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_SUCCESS,
          data: yearsList
      })

    } else {

      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_FAILURE,
        data: { error: 'Se necesita el Id de la marca y/o modelo' }
      })
      
    }
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
